import { render, staticRenderFns } from "./AccountSettingsUserUpgradeFullUser.view.vue?vue&type=template&id=f0c643a4&scoped=true&lang=html&"
import script from "./AccountSettingsUserUpgradeFullUser.view.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsUserUpgradeFullUser.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c643a4",
  null
  
)

export default component.exports